<template>
	<section id="resultado-da-busca">
		<h2>Resultado</h2>
	</section>
</template>

<script>
export default {
	name: 'Resultado'
}
</script>

<style lang="scss" scoped>
#resultado-da-busca {
	h2 {
		color: royalblue;
	}
}
</style>
